import { render, staticRenderFns } from "./BaseIconButton.vue?vue&type=template&id=075ede3a&scoped=true"
import script from "./BaseIconButton.vue?vue&type=script&lang=js"
export * from "./BaseIconButton.vue?vue&type=script&lang=js"
import style0 from "./BaseIconButton.vue?vue&type=style&index=0&id=075ede3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075ede3a",
  null
  
)

export default component.exports